"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setToken = exports.getCurrentProduct = exports.sessionStart = exports.mixpanelWrapper = void 0;

var _mixpanelBrowser = _interopRequireDefault(require("mixpanel-browser"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var mixpanel_sst = _mixpanelBrowser.default;

/**
 * Why do we wrap mixpanel in this way?
 * "Any standard track calls without a specified project name would go to the initial Mixpanel project."
 * https://docs.mixpanel.com/docs/best-practices/developer-environments#send-data-to-multiple-projects
 * But we want to send all calls to both the initial Mixpanel project and the SST project
 */
var mixpanelWrapper = {
  alias: function () {
    var _alias = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _mixpanel_sst$sst;

      var _args = arguments;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _mixpanelBrowser.default.alias.apply(_mixpanelBrowser.default, _args);

            case 2:
              _context.next = 4;
              return (_mixpanel_sst$sst = mixpanel_sst.sst).alias.apply(_mixpanel_sst$sst, _args);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function alias() {
      return _alias.apply(this, arguments);
    }

    return alias;
  }(),
  track: function () {
    var _track = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _mixpanel_sst$sst2;

      var _args2 = arguments;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _mixpanelBrowser.default.track.apply(_mixpanelBrowser.default, _args2);

            case 2:
              _context2.next = 4;
              return (_mixpanel_sst$sst2 = mixpanel_sst.sst).track.apply(_mixpanel_sst$sst2, _args2);

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function track() {
      return _track.apply(this, arguments);
    }

    return track;
  }(),
  track_links: function () {
    var _track_links = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var _mixpanel_sst$sst3;

      var _args3 = arguments;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _mixpanelBrowser.default.track_links.apply(_mixpanelBrowser.default, _args3);

            case 2:
              _context3.next = 4;
              return (_mixpanel_sst$sst3 = mixpanel_sst.sst).track_links.apply(_mixpanel_sst$sst3, _args3);

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function track_links() {
      return _track_links.apply(this, arguments);
    }

    return track_links;
  }(),
  time_event: function () {
    var _time_event = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var _mixpanel_sst$sst4;

      var _args4 = arguments;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _mixpanelBrowser.default.time_event.apply(_mixpanelBrowser.default, _args4);

            case 2:
              _context4.next = 4;
              return (_mixpanel_sst$sst4 = mixpanel_sst.sst).time_event.apply(_mixpanel_sst$sst4, _args4);

            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    function time_event() {
      return _time_event.apply(this, arguments);
    }

    return time_event;
  }(),
  identify: function () {
    var _identify = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      var _mixpanel_sst$sst5;

      var _args5 = arguments;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _mixpanelBrowser.default.identify.apply(_mixpanelBrowser.default, _args5);

            case 2:
              _context5.next = 4;
              return (_mixpanel_sst$sst5 = mixpanel_sst.sst).identify.apply(_mixpanel_sst$sst5, _args5);

            case 4:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    function identify() {
      return _identify.apply(this, arguments);
    }

    return identify;
  }(),
  register: function () {
    var _register = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      var _mixpanel_sst$sst6;

      var _args6 = arguments;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _mixpanelBrowser.default.register.apply(_mixpanelBrowser.default, _args6);

            case 2:
              _context6.next = 4;
              return (_mixpanel_sst$sst6 = mixpanel_sst.sst).register.apply(_mixpanel_sst$sst6, _args6);

            case 4:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    function register() {
      return _register.apply(this, arguments);
    }

    return register;
  }(),
  unregister: function () {
    var _unregister = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
      var _mixpanel_sst$sst7;

      var _args7 = arguments;
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return _mixpanelBrowser.default.unregister.apply(_mixpanelBrowser.default, _args7);

            case 2:
              _context7.next = 4;
              return (_mixpanel_sst$sst7 = mixpanel_sst.sst).unregister.apply(_mixpanel_sst$sst7, _args7);

            case 4:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    function unregister() {
      return _unregister.apply(this, arguments);
    }

    return unregister;
  }(),
  people: {
    increment: function () {
      var _increment = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var _mixpanel$people, _mixpanel_sst$sst$peo;

        var _args8 = arguments;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return (_mixpanel$people = _mixpanelBrowser.default.people).increment.apply(_mixpanel$people, _args8);

              case 2:
                _context8.next = 4;
                return (_mixpanel_sst$sst$peo = mixpanel_sst.sst.people).increment.apply(_mixpanel_sst$sst$peo, _args8);

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function increment() {
        return _increment.apply(this, arguments);
      }

      return increment;
    }(),
    set: function () {
      var _set = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var _mixpanel$people2, _mixpanel_sst$sst$peo2;

        var _args9 = arguments;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return (_mixpanel$people2 = _mixpanelBrowser.default.people).set.apply(_mixpanel$people2, _args9);

              case 2:
                _context9.next = 4;
                return (_mixpanel_sst$sst$peo2 = mixpanel_sst.sst.people).set.apply(_mixpanel_sst$sst$peo2, _args9);

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function set() {
        return _set.apply(this, arguments);
      }

      return set;
    }(),
    set_once: function () {
      var _set_once = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var _mixpanel$people3, _mixpanel_sst$sst$peo3;

        var _args10 = arguments;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return (_mixpanel$people3 = _mixpanelBrowser.default.people).set_once.apply(_mixpanel$people3, _args10);

              case 2:
                _context10.next = 4;
                return (_mixpanel_sst$sst$peo3 = mixpanel_sst.sst.people).set_once.apply(_mixpanel_sst$sst$peo3, _args10);

              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      function set_once() {
        return _set_once.apply(this, arguments);
      }

      return set_once;
    }(),
    union: function () {
      var _union = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var _mixpanel$people4, _mixpanel_sst$sst$peo4;

        var _args11 = arguments;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return (_mixpanel$people4 = _mixpanelBrowser.default.people).union.apply(_mixpanel$people4, _args11);

              case 2:
                _context11.next = 4;
                return (_mixpanel_sst$sst$peo4 = mixpanel_sst.sst.people).union.apply(_mixpanel_sst$sst$peo4, _args11);

              case 4:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));

      function union() {
        return _union.apply(this, arguments);
      }

      return union;
    }()
  }
};
exports.mixpanelWrapper = mixpanelWrapper;

var sessionStart = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
    var getItem,
        setItem,
        currentProduct,
        lastActionTime,
        _args12 = arguments;
    return regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            getItem = _args12.length > 0 && _args12[0] !== undefined ? _args12[0] : localStorage.getItem.bind(localStorage);
            setItem = _args12.length > 1 && _args12[1] !== undefined ? _args12[1] : localStorage.setItem.bind(localStorage);
            currentProduct = _mixpanelBrowser.default.get_property('Current Product');
            lastActionTime = getItem(currentProduct);

            if (!(!lastActionTime || (new Date().getTime() - new Date(lastActionTime).getTime()) / 60000 > _constants.SESSION_TIMEOUT_MINUTES)) {
              _context12.next = 8;
              break;
            }

            _context12.next = 7;
            return mixpanelWrapper.track('Session Start', {});

          case 7:
            // "It is not possible to perform overload resolution based on a list of argument types."
            // https://www.typescriptlang.org/docs/handbook/2/conditional-types.html#inferring-within-conditional-types
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            mixpanelWrapper.people.increment('Number of Sessions');

          case 8:
            mixpanelWrapper.register({
              'Last Action': new Date().toISOString()
            });
            setItem(currentProduct, new Date().toString());

          case 10:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));

  return function sessionStart() {
    return _ref.apply(this, arguments);
  };
}();
/**
 * Gets the current prodcuct thats either passed in, or from the current window
 *  location, or from a passed-in url
 * @param {string} [currentProduct] Optional current product
 * @param {string} [url] A url to get the product for instead of the window location
 * @returns {string} The current product
 */


exports.sessionStart = sessionStart;

var getCurrentProduct = function getCurrentProduct(currentProduct, url) {
  var location = url ? new URL(url) : window.location;

  if (currentProduct) {
    // The current product was explicitly passed in through the template tag
    return currentProduct;
  } // otherwise try to figure it out from the window location


  var key = Object.keys(_constants.PRODUCT_MAP).find(function (product) {
    return location.origin.includes(product);
  });

  if (key) {
    return _constants.PRODUCT_MAP[key] === 'Reports' && location.pathname.includes('/trends') ? 'Trends' : _constants.PRODUCT_MAP[key];
  }

  return null;
};

exports.getCurrentProduct = getCurrentProduct;

var setToken = function setToken(token) {
  _mixpanelBrowser.default.sst.set_config({
    xhr_headers: {
      Authorization: "Bearer ".concat(token)
    }
  });
};

exports.setToken = setToken;